import { useEffect, useState } from "react";
import styles from "../../styles/Components/new-dashboard/DashboardCard.module.css";
import { HiOutlineChevronDown, HiOutlineChevronUp } from "react-icons/hi";

function DashboardCard({
  title,
  titleIcon,
  actions,
  open = false,
  children,
  preview,
  bodyClassName = "",
  type = "",
  id = "",
}) {
  const [isOpen, setIsOpen] = useState(open);

  const openHandler = (e) => {
    e.stopPropagation();
    setIsOpen((prevState) => !prevState);
  };

  const expandCardHandler = (e) => {
    e.stopPropagation();
    if (e.target.id === "dashboard-card-header") {
      setIsOpen((prevState) => !prevState);
    }
  };

  const expandCardWithFooter = () => {
    if (!open) {
      setIsOpen(true);
    }
  };

  useEffect(() => {
    if (
      type === "accountSummary" ||
      type === "botPerformance" ||
      type === "myTasks" ||
      type === "latestSignals" ||
      "topCommunity"
    ) {
      const mediaQuery = window.matchMedia("(min-width: 769px)");

      const handleChange = (e) => {
        setIsOpen(e.matches);
      };

      setIsOpen(mediaQuery.matches);

      mediaQuery.addEventListener("change", handleChange);

      return () => {
        mediaQuery.removeEventListener("change", handleChange);
      };
    }
  }, [open, type]);

  return (
    <div
      className={`${styles.card} ${isOpen ? styles.show : styles.hidden}`}
      id={id || ""}
    >
      <div
        className={styles.cardHeader}
        id="dashboard-card-header"
        onClick={expandCardHandler}
      >
        <h5 className={styles.headerTitle} onClick={openHandler}>
          <span className={styles.headerTitleIcon}>{titleIcon}</span>
          {title}
          <span className={styles.toggleBtn}>
            {!isOpen ? <HiOutlineChevronDown /> : <HiOutlineChevronUp />}
          </span>
        </h5>

        {actions && <div className={styles.headerActions}>{actions}</div>}
      </div>

      <div className={`${styles.cardBody} ${bodyClassName}`}>{children}</div>

      <div className={`${styles.cardFooter}`} onClick={expandCardWithFooter}>
        {preview}
      </div>
    </div>
  );
}

export default DashboardCard;
